/**
 * Streak = giorni CONSECUTIVI con almeno un allenamento, calcolata in ora
 * locale. Una streak valida fino a IERI non va mostrata come zero solo perché
 * oggi non ci si è ancora allenati:
 *  - workout oggi        → si conta a partire da oggi;
 *  - ieri ma non oggi    → si conta a partire da ieri;
 *  - né oggi né ieri     → streak 0.
 *
 * @param {Array<string|number|Date>} logDates date di completamento (es. completed_at)
 * @param {Date} now riferimento "adesso" (iniettabile nei test)
 * @returns {number}
 */
export const computeStreak = (logDates, now = new Date()) => {
  const days = new Set(
    (logDates || []).map((d) => {
      const x = new Date(d);
      x.setHours(0, 0, 0, 0); // giorno locale
      return x.getTime();
    })
  );

  const check = new Date(now);
  check.setHours(0, 0, 0, 0);

  if (!days.has(check.getTime())) {
    // Oggi non (ancora) allenato: la streak può ripartire da ieri
    check.setDate(check.getDate() - 1);
  }

  let streak = 0;
  while (days.has(check.getTime())) {
    streak++;
    check.setDate(check.getDate() - 1);
  }
  return streak;
};
